import React from 'react';
import RibbonSvg from './ribbon.svg';
import WritingExamCompleteRibbonSvg from './writing_exam_complete_ribbon.svg';
import PracticalExamCompleteRibbonSvg from './practical_exam_complete_ribbon.svg';

type Props = {
  className?: string;
  styleName?: string;
};

export const Ribbon = ({ className }: Props) => <img className={className} src={RibbonSvg} />;

export const WritingExamCompleteRibbon = ({ className }: Props) => (
  <img className={className} src={WritingExamCompleteRibbonSvg} />
);
export const PracticalExamCompleteRibbon = ({ className }: Props) => (
  <img className={className} src={PracticalExamCompleteRibbonSvg} />
);
